<template>
  <div class="services-details-bg pt-120 pb-100">
    <div class="container">
      <!-- Responsive image row -->
      <div class="services-details-img d-flex gap-3 mb-4 flex-wrap justify-content-end">
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/badge1.jpg"
          alt="Badge Verification 1"
          class="top-banner-img"
        />
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/badge.jpg"
          alt="Badge Verification 2"
          class="top-banner-img"
        />
      </div>

      <div class="row">
        <div class="col-lg-8">
          <div class="services-details-content">
            <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Verified Badge Services – Instagram | Facebook | WhatsApp</h2>
            <p><strong>Earn the Blue/Green Tick. Gain Trust. Stand Out.</strong></p>
            <p>
              At <strong>MyCelebrity by Digitalentio</strong>, we help influencers, public figures, celebrities,
              and businesses get officially verified on Instagram, Facebook, and WhatsApp...
            </p>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">What We Offer:</h3>
            <ul>
              <li>Instagram & Facebook Blue Tick Verification</li>
              <li>Eligibility Check & Profile Optimization</li>
              <li>PR & Media Coverage Support (if required)</li>
              <li>Application Preparation & Documentation</li>
              <li>Meta Submission Support via official channels</li>
              <li>Verification support for both individuals & brands</li>
            </ul>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">WhatsApp Green Badge for Business:</h3>
            <ul>
              <li>Assistance with WhatsApp Business API onboarding</li>
              <li>Brand authentication with green checkmark</li>
              <li>Integration with verified customer communication tools</li>
              <li>Ideal for medium & large businesses aiming for trust and scale</li>
            </ul>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Benefits of Verification:</h3>
            <ul>
              <li>Blue/Green verified checkmark on profile</li>
              <li>Protection against impersonation</li>
              <li>Enhanced credibility with clients, customers, and followers</li>
              <li>Higher engagement, trust & business opportunities</li>
              <li>Improved brand perception across platforms</li>
            </ul>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Who We’ve Helped:</h3>
            <p>
              We have helped brands like <strong style="color: #0d6efd;">Jos Alukkas, Ramraj Cotton, Arun Ice Cream, Ibaco, Hatsun, Evolveback Kabini,
              Evolveback Coorg, Evolveback Hampi, Evolveback Kalahari, Bharath ATM, Alpino, and wellness brands,</strong>
              regional celebrities, entrepreneurs, and influencers... 
            </p>
          </div>
        </div>

        <div class="col-lg-4 mt-4 mt-lg-0">
          <ServicesSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServicesSidebar from "@/components/ServiceDetails/ServivesSidebar.vue";

export default {
  name: "ServicesDetails",
  components: {
    ServicesSidebar,
  },
};
</script>

<style lang="scss" scoped>
// Light Theme Styles
:deep(body):not(.theme-dark) {
  .services-details-bg {
    background-color: #fff;
    color: #000;
  }
}

// Dark Theme Styles
:deep(body.theme-dark) {
  .services-details-bg {
    background-color: #111;
    color: #fff;
  }
}

.services-details-bg {
  padding-top: 180px;
  padding-bottom: 100px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.services-details-img {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: flex-end;

  .top-banner-img {
    width: 48%;
    max-width: 100%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 20px;
    display: block;
  }
}

.services-details-content {
  padding-top: 20px;

  h2 {
    font-size: 36px;
    margin-bottom: 25px;
  }

  h3 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  h4 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 25px;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 1.2rem;
    margin-bottom: 20px;

    li {
      margin-bottom: 10px;
    }
  }
}

/* Responsive Design */
@media only screen and (max-width: 767px) {
  .services-details-img {
    flex-direction: column;
    align-items: center;

    .top-banner-img {
      width: 100%;
      max-height: 220px;
    }
  }

  .services-details-content h2 {
    font-size: 25px;
    margin-bottom: 15px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .services-details-img .top-banner-img {
    max-height: 300px;
  }

  .services-details-content h2 {
    font-size: 30px;
    margin-bottom: 15px;
  }
}
</style>
